import React from "react";

import { CateringFeatureBlock as Value } from "@reactivated";

import { RichTextBlock } from "@thelabnyc/thelabui/src/components/RichText";
import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { TYPEKIT_URL } from "../../utils/groups";

import groups from "../../styles/groups.module.scss";
import styles from "./index.module.scss";

interface Props {
    value: Value;
}

export const CateringFeatureBlock = (props: Props) => {
    const value = props.value;
    if (!value.heading || !value.body || !value.image) {
        return null;
    }
    const Heading = value.heading_level === "h2" ? "h2" : "h1";
    const cta = value.cta?.url ? value.cta : null;
    return (
        <section className={concatClassNames([groups.tokens, styles.band])}>
            <link rel="stylesheet" href={TYPEKIT_URL} precedence="default" />
            <div className={styles.section}>
                <div className={styles.grid}>
                    <div className={styles.copy}>
                        <Heading className={groups.scriptHeading}>
                            {value.heading}
                        </Heading>
                        <RichTextBlock
                            className={concatClassNames([
                                groups.body,
                                styles.body,
                            ])}
                            value={value.body}
                        />
                        {cta && (
                            <div className={styles.ctaRow}>
                                <a
                                    className={groups.button}
                                    href={cta.url ?? undefined}
                                    target={
                                        cta.link_type === "external"
                                            ? "_blank"
                                            : undefined
                                    }
                                    rel={
                                        cta.link_type === "external"
                                            ? "noreferrer"
                                            : undefined
                                    }
                                >
                                    {cta.display_name || cta.url}
                                </a>
                            </div>
                        )}
                        {value.fineprint && (
                            <p className={styles.fineprint}>
                                {value.fineprint}
                            </p>
                        )}
                    </div>
                    <img
                        className={styles.image}
                        src={value.image.url}
                        alt={value.image.default_alt_text}
                        width={value.image.width}
                        height={value.image.height}
                        loading="lazy"
                    />
                </div>
            </div>
        </section>
    );
};
